module.exports = __webpack_public_path__ + "static/media/FORMULARIO_DE_DBT.55cf80fc.pdf";